var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoMediaResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "50px",
    viewBox: "0 0 63 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-no-media-results") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-569.000000, -2880.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-no-media-results",
    transform: "translate(569.000000, 2880.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75,50 C3.5,50 3.25,49.95 3,49.8 C2.3,49.4 2,48.5 2.45,47.75 L12.65,29.65 C13.55,28.05 15.2,27.1 17,27.1 C18.8,27.1 20.45,28.05 21.35,29.65 C21.75,30.35 21.5,31.3 20.8,31.7 C20.1,32.1 19.15,31.85 18.75,31.15 C18.4,30.5 17.75,30.15 17,30.15 C16.25,30.15 15.6,30.55 15.25,31.15 L5.05,49.25 C4.75,49.75 4.25,50 3.75,50 Z",
    id: "Path",
    fill: "#8499C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,47 L59.9,47 L41.4,14.15 C40.5,12.55 38.85,11.6 37.05,11.6 C35.25,11.6 33.6,12.55 32.7,14.15 L17.75,40.75 C17.35,41.45 17.6,42.4 18.3,42.8 C19,43.2 19.95,42.95 20.35,42.25 L35.3,15.65 C35.65,15 36.3,14.65 37.05,14.65 C37.8,14.65 38.45,15.05 38.8,15.65 L41.55,20.55 C40.15,21.2 38.6,21.5 37.05,21.5 C36.2,21.5 35.55,22.15 35.55,23 C35.55,23.85 36.2,24.5 37.05,24.5 C39.15,24.5 41.15,24.05 43.05,23.15 L56.5,47 L11.5,47 C10.65,47 10,47.65 10,48.5 C10,49.35 10.65,50 11.5,50 L61.5,50 C62.35,50 63,49.35 63,48.5 C63,47.65 62.35,47 61.5,47 Z",
    id: "Path",
    fill: "#8499C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45,29.1 C6.1,29.1 5.75,28.95 5.45,28.7 C2,25.6 0,21.15 0,16.5 C0,7.4 7.4,0 16.5,0 C22.45,0 27.95,3.2 30.85,8.35 C31.25,9.05 31,10 30.3,10.4 C29.6,10.8 28.65,10.55 28.25,9.85 C25.85,5.6 21.35,3 16.5,3 C9.05,3 3,9.05 3,16.5 C3,20.3 4.6,23.95 7.45,26.5 C8.05,27.05 8.1,28 7.55,28.6 C7.25,28.95 6.85,29.1 6.45,29.1 Z",
    id: "Path",
    fill: "#1495CD"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoMediaResults);
export default __webpack_public_path__ + "static/media/icon-no-media-results.fc9e1388987b2792057264f79ca4fda2.svg";
export { ForwardRef as ReactComponent };